import { CrumbItem } from "@/lib/constants"
import Link from "next/link";


const BreadCrumbItem = (props: CrumbItem) => {
  const { name, url, custom_link, link } = props;

  return (
    <>
      {link && url !== null && url !== undefined && url.length > 0 ? (
        <Link href={custom_link !== null ? custom_link : url} className="hover:text-[#2C3E2F] text-xs">
          {name}
        </Link>
      ) : (
        <div className="text-[#2C3E2F] text-xs">{name}</div>
      )}
    </>
  )
}

export default BreadCrumbItem
